module.exports = __webpack_public_path__ + "img/panoplia-dogmatica-1710-pagina-de-titlu-big.78b2432c.jpg";